import { getRequest, postRequest, putRequest } from "@/lib/api";

export type ContentCategory =
  | "HEALTH"
  | "VACCINATION"
  | "TRAINING"
  | "NUTRITION"
  | "WELFARE";
export type ContentStatus = "DRAFT" | "PUBLISHED";
export type ExpertContent = {
  id: string;
  slug: string;
  title: string;
  summary: string;
  body: string;
  category: ContentCategory;
  expertName: string;
  expertCredential: string;
  sourceUrl: string;
  reviewedAt: string;
  status: ContentStatus;
  publishedAt: string | null;
  updatedAt: string;
};
export type SaveExpertContent = Pick<
  ExpertContent,
  | "slug"
  | "title"
  | "summary"
  | "body"
  | "category"
  | "expertName"
  | "expertCredential"
  | "sourceUrl"
  | "reviewedAt"
  | "status"
>;

export const searchContents = (q?: string, category?: string) =>
  getRequest<ExpertContent[]>("contents", {
    q: q || undefined,
    category: category || undefined,
  });
export const getContent = (slug: string) =>
  getRequest<ExpertContent>(`contents/${slug}`);
export const getAdminContents = () =>
  getRequest<ExpertContent[]>("admin/contents");
export const createContent = (input: SaveExpertContent) =>
  postRequest<ExpertContent, SaveExpertContent>("admin/contents", input);
export const updateContent = (id: string, input: SaveExpertContent) =>
  putRequest<ExpertContent, SaveExpertContent>(`admin/contents/${id}`, input);
